// extracted by mini-css-extract-plugin
export var button = "index-module--button--b3x4L";
export var container = "index-module--container--t5h2M";
export var description = "index-module--description--Bvw-q";
export var imageContainer = "index-module--imageContainer----FeP";
export var jobIncentive = "index-module--jobIncentive--5BrU5";
export var mobileGrad = "index-module--mobileGrad--8quBi";
export var normalGrad = "index-module--normalGrad--DE+rq";
export var title = "index-module--title--1g9a6";